
















































import { Component, Vue, Prop } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import UserAvatar from '@/shared/avatars/user/user-avatar.class';
import UserAvatarComponent from '@/shared/avatars/user/user-avatar.component.vue';
import { ProjectMember } from '@/domain/project/project-with-members.entity';

@Component({
  components: {
    UserAvatarComponent,
  },
})
export default class ProjectMembersListComponent extends Vue {
  @Prop() members!: ProjectMember[];

  private get isTheMemberListBigEnough() {
    return this.members.length > 5;
  }
}
